import React from 'react';
import styles from './Reviews.module.css';
import review1 from '../../../src/img/otziv_001.png';
import review2 from '../../../src/img/otziv_002.png';

const Reviews = () => {
  const reviews = [
    {
      id: 1,
      text: "Заселялся в Вашу гостиницу, когда был в командировке по Челябинской области. В этот раз проживал в съемном жилье вместе с бригадой, поэтому понадобились документы для отчета. Оформил и тут меня не подвели, получил все отчетные почтой за 3 дня!",
      name: "Валерий Степанович",
      position: "специалист - метролог",
      avatar: review1
    },
    {
      id: 2,
      text: "Раз в год у нас командировки на повышение квалификации. Ваши услуги здорово помогают дополнительно заработать за эти 3 дня. Очередной раз спасибо за оперативность и честность, за чеками будем обращаться только к вам!",
      name: "Дмитрий",
      position: "коллектив врачей",
      avatar: review2
    }
  ];

  return (
    <section id="reviews" className={styles.reviews}>
      <div className={styles.reviewsBackground}></div>
      <div className="container">
        <div className={styles.reviewsHeader}>
          <h2 className={styles.sectionTitle}>Отзывы клиентов</h2>
        </div>
        
        <div className={styles.reviewsGrid}>
          {reviews.map((review) => (
            <div key={review.id} className={`card ${styles.reviewCard}`}>
              <div className={styles.reviewContent}>
                <p className={styles.reviewText}>{review.text}</p>
                <div className={styles.reviewAuthor}>
                  <div className={styles.reviewAvatar}>
                    <img src={review.avatar} alt={review.name} />
                  </div>
                  <div className={styles.reviewInfo}>
                    <h4 className={styles.reviewName}>{review.name}</h4>
                    <p className={styles.reviewPosition}>{review.position}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.reviewsDividerTop}></div>
      <div className={styles.reviewsDividerBottom}></div>
    </section>
  );
};

export default Reviews;